import React, {useState} from 'react';
import './App.css';
import stc from 'string-to-color';

class ColorForm extends React.Component {
    state = {value: ''};


    handleChange = (event) => {
        this.setState({value: event.target.value});
        this.props.onChange(event.target.value);
    }

    render() {
        return (
            <input style={{padding: '10px 20px', fontSize: '20px', borderRadius: '10px', border: 0}} type="text" value={this.state.value} onChange={this.handleChange} placeholder={'Enter text...'}/>
        );
    }
}

function App() {
    const [text, setText] = useState('');
    const color = stc(text);
    return (
        <div className="App" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100%', backgroundColor: color}}>
            <a href={'https://www.npmjs.com/package/string-to-color'} style={{marginBottom: '20px', fontSize: '30px', color: '#000'}}>string-to-color</a>
            <ColorForm onChange={setText}/>
            <span style={{marginTop: '20px', fontSize: '30px'}}>{color}</span>
        </div>
    );
}

export default App;
